/**
 * @file Float Content.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Float Content component.
 */
const vFloatContent = () => {
	const floatContentBlocks = document.querySelectorAll('.v-float-content');

	if (!floatContentBlocks.length) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	[...floatContentBlocks].forEach((floatContent, index) => {
		const imageContainer = floatContent.querySelector('.v-float-content__images');
		const images = floatContent.querySelectorAll('.v-float-content__image');
		const content = floatContent.querySelector('.v-float-content__content');

		const { contentOrigin, imageOrigin } = floatContent.dataset;
		const contentFrom = {};
		const contentTo = {};
		switch (contentOrigin) {
			case 'left':
				contentFrom.x = '-100vw';
				contentTo.x = 0;
				break;
			case 'bottom':
				contentFrom.y = '100vh';
				contentTo.y = 0;
				break;
			default:
				contentFrom.x = '100vw';
				contentTo.x = 0;
		}

		ScrollTrigger.saveStyles([...images, content]);

		ScrollTrigger.matchMedia({
			'(min-width: 1025px)': () => {
				if (index === 0 && 'fadeBg' in floatContent.dataset) {
					gsap.to('html', {
						backgroundColor: '#000',
						ease:            'sine.out',
						scrollTrigger:   {
							trigger: floatContent,
							start:   'top bottom',
							end:     'top 50%',
							scrub:   true,
						},
					});
				}

				gsap.timeline({
					defaults: {
						ease: 'sine.out',
					},
					scrollTrigger: {
						trigger: imageContainer,
						start:   'top bottom',
						end:     'top 25%',
						scrub:   true,
					},
				})
					.fromTo(images, {
						xPercent: (i) => (60 + (i * -15)) * (imageOrigin === 'left' ? -1 : 1),
					}, {
						xPercent: 0,
					})
					.fromTo(content, contentFrom, contentTo, '<');
			},
		});
	});
};

export default vFloatContent;
